"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceProductDto = exports.ProductDto = exports.DeprecatedProductDto = exports.BaseProductDto = exports.SimpleProductDto = exports.GetOrganizationProductsDto = exports.GetExtraProductDataDto = exports.ProductFieldsDto = exports.GetProductsDto = exports.ProductsIdsDto = exports.AddRequiredProductsDto = exports.ReturnRequiredProductsDto = exports.ConnectProductResourceDto = exports.CreateRentalProductAddonDto = exports.ByProductAndOrgDto = exports.CreateProductAvailabilityTimesDto = exports.FindByProductIdDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class FindByProductIdDto {
}
exports.FindByProductIdDto = FindByProductIdDto;
class CreateProductAvailabilityTimesDto {
}
exports.CreateProductAvailabilityTimesDto = CreateProductAvailabilityTimesDto;
class ByProductAndOrgDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByProductAndOrgDto = ByProductAndOrgDto;
class CreateRentalProductAddonDto {
}
exports.CreateRentalProductAddonDto = CreateRentalProductAddonDto;
class ConnectProductResourceDto {
}
exports.ConnectProductResourceDto = ConnectProductResourceDto;
class ReturnRequiredProductsDto {
}
exports.ReturnRequiredProductsDto = ReturnRequiredProductsDto;
class AddRequiredProductsDto {
}
exports.AddRequiredProductsDto = AddRequiredProductsDto;
class ProductsIdsDto extends general_dto_1.PaginationQuery {
}
exports.ProductsIdsDto = ProductsIdsDto;
class GetProductsDto extends general_dto_1.PaginationQuery {
}
exports.GetProductsDto = GetProductsDto;
class ProductFieldsDto {
}
exports.ProductFieldsDto = ProductFieldsDto;
class GetExtraProductDataDto {
}
exports.GetExtraProductDataDto = GetExtraProductDataDto;
class GetOrganizationProductsDto extends general_dto_1.PaginationQuery {
}
exports.GetOrganizationProductsDto = GetOrganizationProductsDto;
class SimpleProductDto extends general_dto_1.IdAndNameDto {
}
exports.SimpleProductDto = SimpleProductDto;
class BaseProductDto {
}
exports.BaseProductDto = BaseProductDto;
class DeprecatedProductDto extends BaseProductDto {
}
exports.DeprecatedProductDto = DeprecatedProductDto;
class ProductDto extends BaseProductDto {
}
exports.ProductDto = ProductDto;
class ResourceProductDto {
}
exports.ResourceProductDto = ResourceProductDto;
//# sourceMappingURL=product.dto.js.map